// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"c4bfbc0a","513":"12699b95","650":"df6dcf08","690":"75d2db76","703":"fde8112d","787":"3ce4cc4d","912":"76e77d94"}[chunkId] + ".chunk.js";
};